import { initHeroCarouselAnimation } from '../../animation/hero-carousel';

initHeroCarouselAnimation({
  rootSelector: '.js-carousel-hero',
});
